import { VError } from 'errors';
import { NetworkRewardLog, LogApiResponse } from 'types';
import { restService } from 'utilities';

export interface GetNetworkRewardLogsInput {
  referrer?: string;
  fromBlock?: number;
  toBlock?: number | 'latest';
  limit?: number;
}

export interface GetNetworkRewardLogsOutput {
  logs: NetworkRewardLog[];
}

const getNetworkRewardLogs = async ({
  referrer,
  fromBlock,
  toBlock = 'latest',
  limit = 50,
}: GetNetworkRewardLogsInput = {}): Promise<GetNetworkRewardLogsOutput> => {
  const params: Record<string, any> = {
    limit,
  };

  if (referrer) params.referrer = referrer;
  if (fromBlock) params.fromBlock = fromBlock;
  if (toBlock) params.toBlock = toBlock;

  const response = await restService<NetworkRewardLog[]>({
    endpoint: '/logs/network-rewards',
    method: 'GET',
    params,
  });

  if ('result' in response && response.result === 'error') {
    throw new VError({
      type: 'unexpected',
      code: 'somethingWentWrong',
      data: { message: response.message },
    });
  }

  if (!response.data?.data) {
    throw new VError({
      type: 'unexpected',
      code: 'somethingWentWrong',
      data: { message: 'No data received from API' },
    });
  }

  const apiData = response.data.data as unknown as LogApiResponse<NetworkRewardLog[]>;

  if (!apiData.success) {
    throw new VError({
      type: 'unexpected',
      code: 'somethingWentWrong',
      data: { message: apiData.error || 'Failed to fetch network reward logs' },
    });
  }

  return {
    logs: apiData.data || [],
  };
};

export default getNetworkRewardLogs; 